import React, { useState } from "react";
import TimeTable from "../../User/MerchantOnboard/Common/TimeTable";
import GoogleMaps from "../../common/GoogleMaps";
import UploadExcel from "../../common/OfferForm/Location/UploadExcel";
import Input from "../../common/FormInputs";
import PhoneFormInput from "../../common/PhoneInput";

const AddStore = ({
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
  handleTimeChange,
  format,
  uploadClicked,
  setPlaceId,
}) => {
  const [fileData, setFileData] = useState();
  const [fileUrl, setFileUrl] = useState(null);



  const handleLocationSelect = (selectedLocation) => {
    setFieldValue("address", selectedLocation?.placeName);
    setPlaceId(selectedLocation?.placeId);
  };

  const validateFile = (data) => {
    var idxDot = data.lastIndexOf(".") + 1;
    var extFile = data.substr(idxDot, data.length).toLowerCase();
    if (extFile == "xlsx" || extFile == "xls") {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div>
      {uploadClicked === true ? (
        <>
          <p className="font-poppins font-[400] sm:text-[12px] md:text-[14px] text-[#767676] mt-2">
            Upload an excel file
          </p>
          <UploadExcel
            setFileData={setFileData}
            document={values?.document}
            errors={errors}
            touched={touched}
            setFieldValue={setFieldValue}
            accept={".xlsx, .xls"}
            fileText={"Uplaod an excel file"}
            validateFile={validateFile}
            setS3Url={setFileUrl}
          />
        </>
      ) : (
        <>
          <Input
            type="text"
            label=""
            placeholder="Enter store name"
            width="100%"
            radius="5px"
            InputDivClass="w-[100%] mt-8"
            name="storeName"
            value={values?.storeName}
            handleChange={handleChange}
            handleBlur={handleBlur}
            error={errors.storeName}
            touched={touched.storeName}
          />
          <Input
            type="text"
            label=""
            placeholder="Enter email"
            width="100%"
            radius="5px"
            InputDivClass="w-[100%] mt-8"
            name="email"
            value={values?.email}
            handleChange={handleChange}
            handleBlur={handleBlur}
            error={errors.email}
            touched={touched.email}
          />
          <PhoneFormInput
            label={""}
            divClassName="w-full mt-8"
            name="contact"
            value={values?.contact}
            handleBlur={handleBlur}
            error={errors.contact}
            touched={touched.contact}
            setFieldValue={setFieldValue}
            inputStyle={{
              width: "100%",
              border: "none",
            }}
            buttonStyle={{ border: "none" }}
            buttonClass="!rounded-l-[5px] !bg-[#D9D9D9] !w-[25%] md:!w-[15%] lg:!w-[10%] xl:!w-[6%] 2xl:!w-[5%]"
            containerClass="!rounded-[5px] !shadow-none"
            placeholder="Enter Contact Number"
            inputClass="lg:!h-[45px] md:!h-[45px] !rounded-[5px] !bg-[#FFFFFF] !text-[#303030] lg:!text-[14px] sm:!text-[14px] !font-[400] !outline-none !font-poppins !pl-[50px] !shadow-none placeholder:!text-[#767676] placeholder:!text-[14px]"
            labelClass="mb-8"
            errorClass={
              "text-red-600 text-[10px] sm:text-[11px] md:text-[12px] font-[600] ms-1"
            }
          />
          <div className="w-full mt-8" data-field="address">
            <style>{`
                  .merchant-profile-map .gm-fullscreen-control {
                    top: 53px !important;
                  }
                  /* Force show desktop search bar on mobile */
                  .merchant-profile-map .hidden.sm\\:block {
                    display: block !important;
                  }
                  /* Hide default mobile search button */
                  .merchant-profile-map .sm\\:hidden {
                    display: none !important;
                  }
                `}</style>
            <div className="merchant-profile-map h-[300px] md:h-auto">
              <GoogleMaps
                onLocationSelect={handleLocationSelect}
                searchContainerClass="!w-[90%] md:!w-[60%] lg:!w-[50%] !absolute !top-[10px] left-0 right-0 mx-auto md:!right-[10px] md:left-auto md:mx-0 z-10"
                defaultAddress={values?.address}
                placeholder="Add store address"
                searchBarDivClassName="w-full flex items-center h-[50px] relative"
                searchBarInputClassName="navSearchBar h-full w-[100%] ps-[3%] pe-[12%] text-[16px] font-[400] font-poppins outline-none bg-white text-[#303030] rounded-[5px] border border-[#D9D9D9] placeholder:!text-[#767676]"
                searchIconClassName="absolute right-[3%] w-[20px] h-[20px]"
              />
            </div>
            {errors.address && touched.address ? (
              <div className="ms-1 mt-1 w-full flex justify-start items-start">
                <span className="text-red-600 text-[10px] sm:text-[11px] md:text-[12px] font-[600] text-start">
                  {errors.address}
                </span>
              </div>
            ) : null}
          </div>

          <TimeTable
            label={"What are your store hours?"}
            labelClass="text-[14px] md:text-[16px] font-[400] text-[#303030] mb-3 font-poppins"
            openClass="hidden md:block text-[14px] md:text-[16px] font-[400] text-[#8C8C8C] font-poppins ml-[2rem] md:ml-[3rem] lg:ml-[4rem] xl:ml-[6rem]"
            closeClass="hidden md:block text-[14px] md:text-[16px] font-[400] text-[#8C8C8C] font-poppins ml-[0rem]"
            dayClass="text-[12px] md:text-[14px] lg:text-[16px] font-[400] text-[#8C8C8C] mb-2 w-[25%] sm:w-[20%] md:w-[12%] lg:w-[10%] font-poppins"
            timeDivClass="flex items-center gap-1 md:gap-2 w-[65%] sm:w-[75%] md:w-[70%]"
            toClass="text-center text-[12px] md:text-[14px] font-[400] text-[#303030] font-poppins min-w-[20px]"
            timePickerClass="w-full h-[35px] md:h-[40px] rounded-[5px] border border-[#E4E3E4] cursor-pointer"
            format={format}
            timeData={values?.timeData}
            handleTimeChange={handleTimeChange}
            error={errors?.timeData}
            touched={touched?.timeData}
            setFieldValue={setFieldValue}
          />
          {errors?.timeSet && touched?.timeSet ? (
            <span className="text-red-600 sm:text-[10px] md:text-[12px] font-[600] ms-1">
              {errors?.timeSet}
            </span>
          ) : null}
        </>
      )}
    </div>
  );
};

export default AddStore;
